import { render } from "./VisitorProfile.vue?vue&type=template&id=1229e620&scoped=true"
import script from "./VisitorProfile.vue?vue&type=script&lang=js"
export * from "./VisitorProfile.vue?vue&type=script&lang=js"

import "./VisitorProfile.vue?vue&type=style&index=0&id=1229e620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1229e620"]])

export default __exports__